/* ========================================
   HEADER DRAWER - from Lovable Header.tsx
   Scroll state, mobile drawer, dropdowns
   ======================================== */

(function () {
  'use strict';

  function init() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    /* ---------- Scroll state (solid after 30px) ---------- */
    const isTransparent = header.getAttribute('data-transparent') === 'true';
    if (isTransparent) {
      let ticking = false;
      const onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          if (window.scrollY > 30) {
            header.classList.add('header--scrolled');
          } else {
            header.classList.remove('header--scrolled');
          }
          ticking = false;
        });
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      header.classList.add('header--scrolled');
    }

    /* ---------- Desktop dropdowns (hover with delay) ---------- */
    const dropdowns = header.querySelectorAll('[data-nav-dropdown]');
    dropdowns.forEach(function (dd) {
      let openTimer = null;
      let closeTimer = null;

      const open = function () {
        if (closeTimer) clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          dd.classList.add('is-open');
          const btn = dd.querySelector('.header__nav-link');
          if (btn) btn.setAttribute('aria-expanded', 'true');
        }, 60);
      };
      const close = function () {
        if (openTimer) clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          dd.classList.remove('is-open');
          const btn = dd.querySelector('.header__nav-link');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }, 140);
      };

      dd.addEventListener('mouseenter', open);
      dd.addEventListener('mouseleave', close);

      // Keyboard: toggle on click/focus
      const btn = dd.querySelector('.header__nav-link');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = dd.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }
    });

    /* ---------- Mobile drawer ---------- */
    const mobile = header.querySelector('[data-mobile-drawer]');
    const panel = header.querySelector('#MobileDrawer');
    const openBtn = header.querySelector('[data-mobile-open]');
    const closeEls = header.querySelectorAll('[data-mobile-close]');

    const openDrawer = function () {
      if (!mobile) return;
      mobile.classList.add('is-open');
      if (header) header.classList.add('is-menu-open');
      document.body.classList.add('is-menu-open');
      document.body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      if (panel) panel.setAttribute('aria-hidden', 'false');
    };
    const closeDrawer = function () {
      if (!mobile) return;
      mobile.classList.remove('is-open');
      if (header) header.classList.remove('is-menu-open');
      document.body.classList.remove('is-menu-open');
      document.body.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    };

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    closeEls.forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* ---------- Mobile collapsible submenus ---------- */
    const toggles = header.querySelectorAll('[data-mobile-toggle]');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const group = toggle.closest('.header__mobile-group');
        if (!group) return;
        const collapsible = group.querySelector('[data-collapsible]');
        if (!collapsible) return;
        const isOpen = collapsible.getAttribute('data-open') === 'true';
        collapsible.setAttribute('data-open', isOpen ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    /* ---------- Wire up search / cart triggers (dispatch events) ---------- */
    header.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('search:open'));
      });
    });
    header.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (document.body.getAttribute('data-cart-type') === 'page') {
          window.location.href = '/cart';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    });

    /* ---------- Mobile wishlist count badge ---------- */
    var WISHLIST_KEY = 'sync:wishlist';
    function wishCount() {
      try { return (JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []).length; }
      catch (e) { return 0; }
    }
    function paintWishCount() {
      var badge = header.querySelector('[data-wishlist-count]');
      if (!badge) return;
      var n = wishCount();
      if (n > 0) {
        badge.textContent = '(' + n + ')';
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.hidden = true;
      }
    }
    paintWishCount();
    document.addEventListener('wishlist:change', paintWishCount);
    window.addEventListener('storage', function (e) {
      if (e.key === WISHLIST_KEY) paintWishCount();
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
